import http from '@/http/aisea/axios'
const resource = 'polaris'

export default {
  getOffingWavePoint (payload) {
    return http.get(`${resource}/points`, {
      params: {
        lng: payload.lng,
        lat: payload.lat,
        period: payload.period,
      }
    })
  },

  getTyphoonInfo () {
    return http.get(`${resource}/typhoons`, )
  },
}
